export default "__VITE_ASSET__CJYJy9LQ__"